import { useLocation, useNavigate } from 'react-router-dom';

import { useUpgradeSubscription } from '~/modules/settings/hooks/useUpgradeSubscription';
import analytics from '~/services/analytics';

import {
  HomePageV2SidebarActions,
  HomePageV2SidebarNavigationEntry,
} from '../types';

export const useHomePageV2SidebarActions = (
  onAfterNavigate?: () => void,
): HomePageV2SidebarActions => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const fromPath = `${pathname}${search || ''}`;
  const { upgradeSubscription } = useUpgradeSubscription({
    purchaseSource: 'header',
  });

  const navigateFromSidebar = (
    entry: HomePageV2SidebarNavigationEntry,
  ): void => {
    analytics.trackEvent('side_menu_click', {
      button: entry.sideMenuButton,
    });

    onAfterNavigate?.();

    navigate(entry.path, {
      state: {
        from: fromPath,
        with_search: false,
      },
    });
  };

  const navigateFromAccountMenu = (path: string): void => {
    navigate(path, {
      state: {
        from: fromPath,
        with_search: false,
      },
    });
  };

  const handleUpgradeClick = async (): Promise<void> => {
    analytics.trackEvent('subscription - sub promo button click');
    await upgradeSubscription();
  };

  return {
    activePath: pathname,
    navigateFromSidebar,
    navigateFromAccountMenu,
    handleUpgradeClick,
  };
};
